<template>
<v-container class="code-form">
  <v-form ref="form" v-model="valid" :lazy-validation="false">
    <v-row>
      <v-col cols="3">優惠代碼</v-col>
      <v-col cols="9">
        <v-text-field
          v-model="codeForm.promoCode"
          label="請輸入優惠代碼"
          :disabled="isEdit"
          :rules="codeRule"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" >使用情境</v-col>
      <v-col cols="9" class="text-left">
        <v-radio-group v-model="codeForm.promotionFor">
          <v-radio
            v-for="n in swap"
            :key="n.text"
            :label="n.text"
            :value="n.value"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" >折扣方式</v-col>
      <v-col cols="9" class="text-left">
        <v-radio-group v-model="codeForm.discountType">
          <v-radio :value="1">
            <template slot="label">手續費扣點</template>
          </v-radio>
          <v-text-field v-model="codeForm.serviceFee"
                        label="請輸入折扣數字"
                        :rules="numberRule"
                        :disabled="codeForm.discountType !== 1"></v-text-field>
          <v-radio :value="2" >
            <template slot="label">手續費打折</template>
          </v-radio>
          <v-text-field v-model="codeForm.serviceFeePercentage"
                        label="請輸入打折成數，ex: 打8折，請輸入20"
                        :rules="numberRule"
                        :disabled="codeForm.discountType !== 2"></v-text-field>
          <template v-if="isSwapOut">
            <v-radio :value="3">
              <template slot="label">商品扣點
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="black" small dark v-bind="attrs" v-on="on">
                      mdi-information
                    </v-icon>
                  </template>
                  <span>適用於純點及點＋金商品，僅會扣除上述商品中的「點」</span>
                </v-tooltip>
              </template>
            </v-radio>
            <v-text-field v-model="codeForm.point"
                          label="請輸入折扣數字"
                          :rules="numberRule"
                          :disabled="codeForm.discountType !== 3"></v-text-field>
            <v-radio :value="4">
              <template slot="label">商品折點
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="black" small dark v-bind="attrs" v-on="on">
                      mdi-information
                    </v-icon>
                  </template>
                  <span>適用於純點及點＋金商品，僅會打折上述商品中的「點」</span>
                </v-tooltip>
              </template>
            </v-radio>
            <v-text-field v-model="codeForm.pointPercentage"
                          label="請輸入打折成數，ex: 打8折，請輸入20"
                          :rules="numberRule"
                          :disabled="codeForm.discountType !== 4"></v-text-field>
            <v-radio :value="5">
              <template slot="label">商品扣金
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="black" small dark v-bind="attrs" v-on="on">
                      mdi-information
                    </v-icon>
                  </template>
                  <span>適用於點＋金及純金商品，僅會扣除上述商品中的「金」</span>
                </v-tooltip>
              </template>
            </v-radio>
            <v-text-field v-model="codeForm.cash"
                          label="請輸入折扣數字"
                          :rules="numberRule"
                          :disabled="codeForm.discountType !== 5"></v-text-field>
            <v-radio :value="6">
              <template slot="label">商品折金
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="black" small dark v-bind="attrs" v-on="on">
                      mdi-information
                    </v-icon>
                  </template>
                  <span>適用於點＋金及純金商品，僅會打折上述商品中的「金」</span>
                </v-tooltip>
              </template>
            </v-radio>
            <v-text-field v-model="codeForm.cashPercentage"
                          label="請輸入打折成數，ex: 打8折，請輸入20"
                          :rules="numberRule"
                          :disabled="codeForm.discountType !== 6"></v-text-field>
            <v-radio :value="0">
              <template slot="label">單純推薦</template>
            </v-radio>
          </template>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row v-if="isSwapOut">
      <v-col cols="3" >適用範圍:商品分類</v-col>
      <v-col cols="9">
        <v-autocomplete
          id="idtype"
          v-model="codeForm.categories"
          :items="typeSelect"
          :rules="typeRule"
          clearable
          multiple
          chips
          deletable-chips
          >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row v-if="isSwapOut">
      <v-col cols="3">適用範圍:商品標籤</v-col>
      <v-col cols="9" class="text-left">
        <v-autocomplete
          id="idtag"
          v-model="codeForm.tags"
          :items="tagSelect"
          :rules="tagRule"
          clearable
          multiple
          chips
          deletable-chips
        ></v-autocomplete>
        </v-col>
      </v-row>
    <v-row>
      <v-col cols="3">生效日期</v-col>
      <v-col cols="9">
        <DateRange
          label="生效日期"
          v-model="codeForm.startOn"
          :rules="dateRule"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">失效日期</v-col>
      <v-col cols="9">
        <DateRange
          label="失效日期"
          v-model="codeForm.endOn"
          :rules="dateRule"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-right">
        <v-btn class="mr-4" @click="handleBack">
          取消
        </v-btn>
        <v-btn class="mr-4" @click="handleSubmit">
          確認
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
  </v-container>
</template>

<script>
import api from '@/api';
import itemMixin from '@/minix/itemMixin';
import ruleMixin from '@/minix/ruleMixin';
import DateRange from '@/components/DateRange.vue';
import moment from 'moment';

export default {
  mixins: [itemMixin, ruleMixin],
  components: {
    DateRange,
  },
  data() {
    return {
      valid: true,
      swap: [
        { text: '換入', value: 1 },
        { text: '換出', value: 2 },
      ],
      types: [],
      tags: [],
      codeForm: {
        promoCode: '',
        promotionFor: 1,
        discountType: 1,
        serviceFee: 0,
        serviceFeePercentage: 0,
        point: 0,
        pointPercentage: 0,
        cash: 0,
        cashPercentage: 0,
        tags: [],
        categories: [],
        startOn: '',
        endOn: '',
        isEnabled: true,
      },
      codeRule: this.requiredRule('優惠代碼'),
      // discountRule: this.requiredRule('折扣方式'),
      dateRule: this.requiredRule('日期'),
      typeRule: [
        this.applyValidate(((v) => v.codeForm.tags), '商品分類'),
      ],
      tagRule: [
        this.applyValidate(((v) => v.codeForm.categories), '商品標籤'),
      ],
      numberRule: [
        (v) => !v || /^[0-9]+(.[0-9]{1,2})?$/.test(v) || '必須為數字或折數，ex:10、0.05',
      ],
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'codeForm.tags': function (newval, oldval) {
      this.applyWatcher();
    },
    // eslint-disable-next-line func-names
    'codeForm.categories': function (newval, oldval) {
      this.applyWatcher();
    },
  },
  async created() {
    if (this.isEdit) {
      this.getCodeInfo();
    }
  },
  computed: {
    isEdit() {
      return this.$route.name === 'promotion-code-edit';
    },
    promoCode() {
      return this.$route.params.pcode;
    },
    isSwapOut() {
      return this.codeForm.promotionFor === 2;
    },
  },
  filters: {
    date(value) {
      return moment(value).format('YYYY-MM-DD');
    },
  },
  methods: {
    async getCodeInfo() {
      const { data } = await api.promotion.get(this.promoCode);
      this.codeForm = {
        promoCode: data.promoCode,
        promotionFor: data.promotionFor,
        discountType: data.discountType,
        serviceFee: data.serviceFee,
        serviceFeePercentage: data.serviceFeePercentage,
        point: data.point,
        pointPercentage: data.pointPercentage,
        cash: data.cash,
        cashPercentage: data.cashPercentage,
        tags: data.tags || [],
        categories: data.categories || [],
        startOn: moment(data.startOn).format('YYYY-MM-DD'),
        endOn: moment(data.endOn).format('YYYY-MM-DD'),
        isEnabled: data.isEnabled,
      };
    },
    handleBack() {
      this.$router.push({ name: 'promotion-code-list' });
    },
    async handleSubmit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const { status } = this.isEdit
        ? await api.promotion.edit(this.codeForm.promoCode, this.codeForm)
        : await api.promotion.add(this.codeForm);
      if (status === 1) {
        this.handleBack();
      }
    },
    applyValidate(func, message) {
      return (source) => {
        const items = func(this);
        return (source.length + items.length) > 0 || `請選擇${message}`;
      };
    },
    applyWatcher() {
      const inputs = this.$refs.form.inputs.filter(
        (i) => i.id === 'idtype' || i.id === 'idtag',
      );
      inputs.forEach((input) => {
        input.validate(true);
      });
    },
  },
};
</script>
